<div class="row apt-container justify-content-center mb-4">
    <div class="col-2 text-center apt-timeline">
        <div class="bullet"></div>
        <div class="apt-time-text my-1"><strong>{{appointment.start | date:'d MMM, y HH:mm'}}</strong></div>
        <div class="v-line"></div>
    </div>
    <div class="col-10 apt-details text-capitalize" [ngClass]="{'disabled-card': appointment.isDeleted}">
        <mat-card class="apt-details-card">
            <mat-card-header>
                <mat-card-title-group>
                    <mat-card-title class="u-name text-capitalize">{{appointment.practitioner.firstName}}
                        {{appointment.practitioner.lastName}}</mat-card-title>
                </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="mt-3">
                <div class="row">
                    <div class="col-4">
                        <div class="label">Visit Type</div>
                        <div class="value">{{appointment.appointmentType}}</div>
                    </div>
                    <div class="col-4">
                        <div class="label">Duration</div>
                        <div class="value">{{appointment.start|timeDifference:appointment.end}}</div>
                    </div>
                    <div class="col-4">
                        <div class="label">Action</div>
                        <div [ngClass]="{'disabled-card': appointment.isDeleted || appointment.hasTranscription || appointment.pastAppointment}"
                            fxLayout="row wrap" fxLayoutAlign="center start" fxLayoutGap="8px">
                            <ng-container *ngIf="!appointment.isDeleted">
                                <button type="button" mat-icon-button class="md-small"
                                    (click)="onAction($event,'delete')">
                                    <i class="bi bi-trash3"></i>
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12">
                        <div class="label">Reason</div>
                        <div class="value notes-field text-break" [cvaTrimText]="appointment.notes">
                            {{appointment.notes}}</div>
                    </div>

                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>